import React from 'react';
import { Table } from 'react-bootstrap';
import { AssetMaintenancePhotos } from './AssetMaintenancePhotos';

export function AssetPmTaskResults({ tasks, kind, recordId }) {
    return (
        <Table responsive bordered size="sm">
            <thead>
                <tr>
                    <th style={{ width: 48 }}>#</th>
                    <th>Task</th>
                    <th style={{ width: 90 }}>Done</th>
                    <th>Remarks</th>
                </tr>
            </thead>
            <tbody>
                {tasks.map((task) => (
                    <tr key={task.seq}>
                        <td>{task.seq}</td>
                        <td>
                            {task.description || <span className="text-muted">—</span>}
                            {!!task.attachmentIds?.length && (
                                <AssetMaintenancePhotos
                                    kind={kind}
                                    parentType="schedule"
                                    attachmentIds={task.attachmentIds}
                                    taskSeq={task.seq}
                                    readOnly
                                    displayAsLinks
                                />
                            )}
                            {!!task.completionAttachmentIds?.length && (
                                <AssetMaintenancePhotos
                                    kind={kind}
                                    parentType="maintenance"
                                    parentId={recordId}
                                    taskSeq={task.seq}
                                    attachmentIds={task.completionAttachmentIds}
                                    readOnly
                                    displayAsLinks
                                />
                            )}
                        </td>
                        <td className="text-center">{task.completed ? 'Yes' : ''}</td>
                        <td style={{ whiteSpace: 'pre-wrap' }}>{task.remarks || ''}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}
